import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { TippyV2 } from "@/react/components/shared/TippyV2";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { useMarkAllChatRoomAsRead } from "@/react/hooks/chatsV2/useMarkAllChatRoomAsRead";
import { useShouldShowMessagingRoutes } from "@/react/hooks/useIsMessagingEnabled";
import { IconButton } from "../../IconButton";

export const MarkAsReadButton = () => {
  const { currentCommunitySettings } = usePunditUserContext();
  const { chat_mark_all_as_read_enabled: isChatMarkAllAsReadEnabled } =
    currentCommunitySettings || {};
  const { showMessagesTab: shouldShowMessagesTab } =
    useShouldShowMessagingRoutes();

  const { markAllChatRoomAsRead, isLoading } = useMarkAllChatRoomAsRead();

  if (!isChatMarkAllAsReadEnabled || !shouldShowMessagesTab) {
    return null;
  }

  if (isLoading) {
    return (
      <div className="bg-secondary flex size-6 items-center justify-center rounded">
        <Icon type="live-spinner" className="size-4 animate-spin" />
      </div>
    );
  }
  return (
    <TippyV2 interactive={false} content={t("header_v3.mark_all_as_read")}>
      <IconButton
        name="16-mark-as-read"
        onClick={markAllChatRoomAsRead}
        ariaLabel={t("header_v3.mark_all_as_read")}
        iconClassName="!text-dark"
      />
    </TippyV2>
  );
};
